import { Modal } from "@4uhub/lib4uhub";
import CommentRoundedIcon from "@mui/icons-material/CommentRounded";
import { Box, Typography } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { ICommentsModalProps } from "./models";

export const CommentsModal = memo(
  ({ open, justifications, onClose }: ICommentsModalProps) => {
    const { t } = useTranslation();

    return (
      <Modal
        open={open}
        onClose={onClose}
        title={`${t("components.panel.comments")}`}
      >
        {justifications.map((jt, index) => (
          <Box
            key={jt.date + index}
            sx={(t) => ({
              pb: 2,
              display: "flex",
              alignItems: "start",
              gap: 2,
              borderBottom:
                justifications.length > 0 && index < justifications.length - 1
                  ? "1px solid"
                  : "none",
              borderColor: t.palette.divider,
            })}
          >
            <Box
              sx={(t) => ({
                mt: 1,
                p: 3,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: 20,
                backgroundColor:
                  t.palette.mode === "light"
                    ? t.palette.primary.dark
                    : t.palette.primary.light,
                color: t.palette.primary.contrastText,
              })}
            >
              <CommentRoundedIcon />
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Typography>{jt.justification}</Typography>
              <Typography
                variant="subtitle2"
                sx={(t) => ({
                  color: t.palette.grey[t.palette.mode === "light" ? 600 : 400],
                })}
              >
                {jt.date}
              </Typography>
            </Box>
          </Box>
        ))}
      </Modal>
    );
  }
);
